import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LocaleProvider } from "@/contexts/LocaleContext";
import LandingPage from "@/pages/LandingPage";
import MarketplacePage from "@/pages/MarketplacePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PendingPage from "@/pages/PendingPage";
import LotDetailPage from "@/pages/LotDetailPage";
import BuyerDashboardPage from "@/pages/BuyerDashboardPage";
import CooperativeDashboardPage from "@/pages/CooperativeDashboardPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ToursPage from "@/pages/ToursPage";
import TourDetailPage from "@/pages/TourDetailPage";
import { InstallPrompt } from "@/components/brand/InstallPrompt";

export default function App() {
  return (
    <ThemeProvider>
      <LocaleProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/pending" element={<PendingPage />} />
              <Route path="/lot/:id" element={<LotDetailPage />} />
              <Route path="/buyer" element={<BuyerDashboardPage />} />
              <Route path="/cooperative" element={<CooperativeDashboardPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/tours" element={<ToursPage />} />
              <Route path="/tours/:id" element={<TourDetailPage />} />
            </Routes>
          </BrowserRouter>
          <InstallPrompt />
          <Toaster position="top-right" toastOptions={{
            classNames: {
              toast: "rounded-none border border-border bg-card",
            },
          }} />
        </AuthProvider>
      </LocaleProvider>
    </ThemeProvider>
  );
}
